import React from 'react'


export default function JoinTheApp() {

    return (
        <div>
            <div className="join-the-app-title">
                <span>Join your friends<br/>on the VIA Academy App</span>
            </div>
            <div className="join-the-app-section">
                <div className="join-app-buttons">
                    <a href="https://apps.apple.com/us/app/via-academy/id1561976464" className="btn btn-app-store">&nbsp;</a>
                    <a href="https://play.google.com/store/apps/details?id=io.kaizhan.vfa" className="btn btn-google-play">&nbsp;</a>
                </div>
                <div className="join-app-buttons">
                    <span className="btn btn-scan-me">&nbsp;</span>
                </div>
            </div>
        </div>

)


}
